import { Helmet } from "react-helmet-async";

function SEO({
    title,
    description,
    keywords,
    canonical,
    image = "https://feesworth.com/image.jpg",
}) {
    return (
        <Helmet>

            {/* =================================================
                BASIC SEO
            ================================================= */}

            <title>{title}</title>

            <meta
                name="description"
                content={description}
            />

            <meta
                name="keywords"
                content={keywords}
            />

            <meta
                name="robots"
                content="index, follow"
            />

            <link
                rel="canonical"
                href={canonical}
            />


            {/* =================================================
                OPEN GRAPH
            ================================================= */}

            <meta
                property="og:type"
                content="website"
            />

            <meta
                property="og:title"
                content={title}
            />

            <meta
                property="og:description"
                content={description}
            />

            <meta
                property="og:url"
                content={canonical}
            />

            <meta
                property="og:image"
                content={image}
            />

            <meta
                property="og:site_name"
                content="FeesWorth"
            />


            {/* =================================================
                TWITTER
            ================================================= */}

            <meta
                name="twitter:card"
                content="summary_large_image"
            />

            <meta
                name="twitter:title"
                content={title}
            />

            <meta
                name="twitter:description"
                content={description}
            />

            <meta
                name="twitter:image"
                content={image}
            />

        </Helmet>
    );
}

export default SEO;